import proyecto from "../../api/Proyecto";

export const getVentasPendientes = async ({ limit = 50, offset = 0, felEstado = "", all = true } = {}) => {
  const params = new URLSearchParams();
  params.set("limit", String(limit));
  params.set("offset", String(offset));
  if (all) params.set("all", "true");
  if (felEstado) params.set("felEstado", String(felEstado));
  const res = await proyecto.get(`/ventas/pendientes?${params.toString()}`);
  return res.data;
};

export const getVentaDetalle = async (idVenta) => {
  const res = await proyecto.get(`/ventas/${idVenta}`);
  return res.data;
};

export const certificarFelVenta = async (idVenta) => {
  const res = await proyecto.post(`/ventas/${idVenta}/certificar-fel`, {});
  return res.data;
};

export const anularVenta = async (idVenta, { motivo = "ANULACION", anularFel = true } = {}) => {
  const res = await proyecto.post(`/ventas/${idVenta}/anular`, { motivo, anularFel });
  return res.data;
};
